/** Block-coord key for loadedChunks / waitingSpiralChunksLoad (matches worldView.loadChunk). */
export function updateLightRemeshBlockKey(chunkX, chunkZ) {
    const bx = chunkX * 16;
    const bz = chunkZ * 16;
    return `${bx},${bz}`;
}
